import { partIdentifiersEditFormSchema, } from './identifiers-form.js';
export const PART_IDENTIFIERS_FORM_FIELD_KEYS = Object.keys(partIdentifiersEditFormSchema.shape);
export function toUpdatePartInputFromIdentifiersForm(values, dirtyFields) {
    const parsed = partIdentifiersEditFormSchema.parse(values);
    const input = {};
    if (dirtyFields.upc)
        input.upc = parsed.upc || null;
    if (dirtyFields.url)
        input.url = parsed.url || null;
    if (dirtyFields.alertNote)
        input.alertNote = parsed.alertNote || null;
    if (dirtyFields.abcCode)
        input.abcCode = parsed.abcCode || null;
    return input;
}
//# sourceMappingURL=identifiers-mapper.js.map